"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapGlobalApiProductListToList = void 0;
var _filterProductsFromApi = require("./filterProductsFromApi");
const mapGlobalApiProductListToList = ({
  list: {
    description,
    items,
    lastUpdate,
    name,
    productListId
  },
  type
}) => ({
  id: productListId,
  description: description == null || description === '' ? undefined : description,
  lastUpdate,
  name: name ?? '',
  productCodes: (0, _filterProductsFromApi.filterProductsFromApi)(items),
  type
});
exports.mapGlobalApiProductListToList = mapGlobalApiProductListToList;
